module.exports = __webpack_public_path__ + "img/2025.46e57635.png";